module.exports = __webpack_public_path__ + "static/media/Bronzor_gaussian2.b640f407.png";